import React, { useState } from 'react';

const Timeline = () => {
  const [selectedMonth, setSelectedMonth] = useState(null);

  const roadmapData = [
    {
      month: "September 2025",
      monthNumber: "09",
      icon: "fas fa-rocket",
      color: "from-blue-500 to-purple-600",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-500",
      activities: [
        {
          title: "Sosialisasi Program",
          category: "Program Utama, Program Media",
          description: "Memperkenalkan program digitalisasi kepada seluruh stakeholder",
          icon: "fas fa-bullhorn",
          rationale: "Sosialisasi di awal sangat penting untuk membangun pemahaman dan dukungan dari semua pihak. Tanpa dukungan penuh dari guru, santri, dan wali santri, program digitalisasi akan sulit berhasil."
        },
        {
          title: "Audit Infrastruktur IT",
          category: "Program Utama",
          description: "Evaluasi menyeluruh kesiapan infrastruktur teknologi",
          icon: "fas fa-network-wired",
          rationale: "Infrastruktur yang solid adalah fondasi utama digitalisasi. Audit ini memastikan jaringan WiFi, server, dan perangkat pendukung siap menangani beban sistem digital yang akan diimplementasi."
        },
        {
          title: "Workshop Pembuatan RPP Digital WIIBS",
          category: "Program Pendidikan, Program QA/Balitbangwas",
          description: "Pelatihan guru dalam menyusun Rencana Pelaksanaan Pembelajaran berbasis digital",
          icon: "fas fa-chalkboard-teacher",
          rationale: "RPP Digital adalah jantung pembelajaran modern. Workshop ini memastikan guru memiliki kompetensi untuk merancang pembelajaran yang efektif menggunakan teknologi iPad dan LMS."
        },
        {
          title: "Finalisasi Template RPP Digital",
          category: "Program Pendidikan, Program QA/Balitbangwas",
          description: "Standardisasi format dan template RPP Digital untuk konsistensi",
          icon: "fas fa-file-alt",
          rationale: "Template yang terstandar memudahkan guru dalam membuat RPP dan memastikan kualitas pembelajaran yang konsisten di seluruh unit pendidikan."
        }
      ]
    },
    {
      month: "Oktober 2025",
      monthNumber: "10",
      icon: "fas fa-cogs",
      color: "from-green-500 to-teal-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-500",
      activities: [
        {
          title: "Setup Lanjutan MDM & LMS",
          category: "Program Utama",
          description: "Konfigurasi sistem manajemen perangkat dan platform pembelajaran",
          icon: "fas fa-server",
          rationale: "MDM dan LMS adalah tulang punggung sistem digital. Setup yang tepat memastikan kontrol penuh atas perangkat iPad dan platform pembelajaran yang stabil untuk ribuan pengguna."
        },
        {
          title: "Perancangan Akun Guru dan Kelas",
          category: "Program Utama, Program Pendidikan",
          description: "Strukturisasi sistem akun dan hierarki kelas dalam LMS",
          icon: "fas fa-users-cog",
          rationale: "Struktur akun yang terorganisir memudahkan manajemen pembelajaran dan memastikan setiap guru memiliki akses yang tepat sesuai dengan tanggung jawabnya."
        },
        {
          title: "Integrasi RPP Digital dengan LMS",
          category: "Program Pendidikan",
          description: "Menghubungkan rencana pembelajaran dengan platform digital",
          icon: "fas fa-link",
          rationale: "Integrasi ini memungkinkan guru untuk langsung mengimplementasikan RPP dalam bentuk digital, membuat pembelajaran lebih interaktif dan terukur."
        }
      ]
    },
    {
      month: "November 2025",
      monthNumber: "11",
      icon: "fas fa-clipboard-list",
      color: "from-orange-500 to-red-600",
      bgColor: "bg-orange-50",
      borderColor: "border-orange-500",
      activities: [
        {
          title: "Penyusunan SOP iPad & LMS",
          category: "Program Utama",
          description: "Pembuatan Standard Operating Procedure untuk penggunaan perangkat",
          icon: "fas fa-clipboard-check",
          rationale: "SOP yang jelas mencegah penyalahgunaan perangkat dan memastikan penggunaan iPad sesuai dengan tujuan pendidikan. Ini penting untuk menjaga disiplin dan fokus belajar santri."
        },
        {
          title: "Uji Coba Pembelajaran Digital",
          category: "Program Pendidikan",
          description: "Implementasi blended dan flipped classroom secara terbatas",
          icon: "fas fa-flask",
          rationale: "Uji coba memungkinkan identifikasi masalah sebelum implementasi penuh. Metode blended dan flipped classroom terbukti meningkatkan engagement dan hasil belajar siswa."
        },
        {
          title: "Susun Draft SOP Penggunaan iPad di Asrama",
          category: "Program Pengasuhan",
          description: "Aturan khusus penggunaan iPad dalam lingkungan boarding school",
          icon: "fas fa-home",
          rationale: "Lingkungan asrama memiliki karakteristik unik dengan jadwal ibadah dan istirahat yang ketat. SOP khusus memastikan iPad tidak mengganggu aktivitas spiritual dan sosial santri."
        }
      ]
    },
    {
      month: "Desember 2025",
      monthNumber: "12",
      icon: "fas fa-tablet-alt",
      color: "from-purple-500 to-pink-600",
      bgColor: "bg-purple-50",
      borderColor: "border-purple-500",
      activities: [
        {
          title: "Pengadaan iPad Siswa Pilot",
          category: "Program Utama",
          description: "Distribusi perangkat untuk kelas uji coba terpilih",
          icon: "fas fa-box-open",
          rationale: "Implementasi bertahap dengan kelas pilot memungkinkan pembelajaran dari pengalaman nyata sebelum ekspansi ke seluruh sekolah. Ini mengurangi risiko dan memastikan kesiapan sistem."
        },
        {
          title: "Pelatihan Guru Lanjutan",
          category: "Program Utama",
          description: "Pendalaman kemampuan guru dalam menggunakan fitur-fitur advanced",
          icon: "fas fa-graduation-cap",
          rationale: "Guru adalah kunci sukses digitalisasi. Pelatihan lanjutan memastikan mereka tidak hanya bisa menggunakan teknologi, tetapi juga mengoptimalkannya untuk pembelajaran yang efektif."
        },
        {
          title: "Produksi Konten Semester Genap",
          category: "Program Utama",
          description: "Pembuatan materi pembelajaran digital untuk semester mendatang",
          icon: "fas fa-video",
          rationale: "Konten berkualitas adalah isi dari wadah teknologi. Produksi konten yang sistematis memastikan pembelajaran digital memiliki substansi yang kaya dan relevan."
        }
      ]
    },
    {
      month: "Januari 2026",
      monthNumber: "01",
      icon: "fas fa-chart-line",
      color: "from-indigo-500 to-blue-600",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-500",
      activities: [
        {
          title: "Integrasi Penilaian Digital",
          category: "Program Utama, Program Pendidikan, Program Pengasuhan",
          description: "Penggabungan sistem penilaian akademik dan karakter dalam platform digital",
          icon: "fas fa-chart-bar",
          rationale: "Penilaian terintegrasi memberikan gambaran holistik perkembangan santri. Kombinasi nilai akademik dan karakter dalam satu sistem memudahkan monitoring dan evaluasi komprehensif."
        },
        {
          title: "Penerapan Assessment for/as/of Learning",
          category: "Program Pendidikan, Program Pengasuhan",
          description: "Implementasi berbagai jenis penilaian berbasis digital",
          icon: "fas fa-tasks",
          rationale: "Variasi metode assessment memungkinkan evaluasi yang lebih akurat dan adil. Assessment digital juga memberikan feedback real-time yang membantu proses pembelajaran."
        },
        {
          title: "Input Data Absensi dan Ibadah ke LMS",
          category: "Program Pengasuhan",
          description: "Digitalisasi pencatatan kehadiran dan aktivitas spiritual santri",
          icon: "fas fa-pray",
          rationale: "Data digital memungkinkan monitoring real-time oleh wali santri dan membantu identifikasi pola perilaku yang memerlukan perhatian khusus."
        }
      ]
    },
    {
      month: "Februari 2026",
      monthNumber: "02",
      icon: "fas fa-user-graduate",
      color: "from-pink-500 to-rose-600",
      bgColor: "bg-pink-50",
      borderColor: "border-pink-500",
      activities: [
        {
          title: "Pelatihan Siswa Pilot",
          category: "Program Utama",
          description: "Orientasi penggunaan iPad dan LMS untuk santri kelas pilot",
          icon: "fas fa-users",
          rationale: "Santri perlu memahami cara menggunakan teknologi secara bertanggung jawab. Pelatihan ini memastikan mereka dapat memanfaatkan iPad untuk pembelajaran, bukan hiburan."
        },
        {
          title: "Simulasi RPP Digital Penuh",
          category: "Program Pendidikan",
          description: "Uji coba pembelajaran digital lengkap dengan penilaian formatif",
          icon: "fas fa-play-circle",
          rationale: "Simulasi penuh memberikan gambaran nyata tentang implementasi sistem. Ini memungkinkan penyesuaian dan perbaikan sebelum peluncuran resmi."
        },
        {
          title: "Edukasi Adab Digital",
          category: "Program Pengasuhan",
          description: "Pembinaan etika dan moral dalam penggunaan teknologi",
          icon: "fas fa-heart",
          rationale: "Teknologi harus sejalan dengan nilai-nilai islami. Edukasi adab digital memastikan santri menggunakan teknologi dengan akhlak yang baik dan tujuan yang mulia."
        }
      ]
    },
    {
      month: "Maret 2026",
      monthNumber: "03",
      icon: "fas fa-search",
      color: "from-teal-500 to-cyan-600",
      bgColor: "bg-teal-50",
      borderColor: "border-teal-500",
      activities: [
        {
          title: "Evaluasi Pilot Project",
          category: "Program Utama",
          description: "Penilaian menyeluruh terhadap hasil uji coba sistem digital",
          icon: "fas fa-clipboard-list",
          rationale: "Evaluasi objektif diperlukan untuk mengidentifikasi keberhasilan dan kekurangan sistem. Data dari pilot project menjadi dasar perbaikan sebelum implementasi penuh."
        },
        {
          title: "Laporan Evaluasi Mutu Pilot Project",
          category: "Program QA/Balitbangwas",
          description: "Dokumentasi hasil evaluasi dan rekomendasi perbaikan",
          icon: "fas fa-file-contract",
          rationale: "Dokumentasi yang baik memastikan pembelajaran dari pilot project tidak hilang dan dapat dijadikan referensi untuk pengembangan selanjutnya."
        },
        {
          title: "Evaluasi Mutu Asesmen Digital",
          category: "Program Pendidikan",
          description: "Analisis efektivitas rubrik, portofolio, dan project-based learning digital",
          icon: "fas fa-award",
          rationale: "Asesmen digital harus terbukti lebih efektif dari metode konvensional. Evaluasi ini memastikan kualitas penilaian tidak menurun dengan digitalisasi."
        }
      ]
    },
    {
      month: "April 2026",
      monthNumber: "04",
      icon: "fas fa-expand-arrows-alt",
      color: "from-yellow-500 to-orange-600",
      bgColor: "bg-yellow-50",
      borderColor: "border-yellow-500",
      activities: [
        {
          title: "Distribusi iPad Siswa Batch Akhir",
          category: "Program Utama",
          description: "Penyebaran perangkat ke seluruh santri di semua unit",
          icon: "fas fa-shipping-fast",
          rationale: "Setelah pilot project berhasil, saatnya ekspansi penuh. Distribusi bertahap memastikan proses berjalan lancar dan semua santri mendapat perangkat yang sama."
        },
        {
          title: "Setup Sistem Penuh di Semua Unit",
          category: "Program Utama",
          description: "Implementasi LMS dan MDM di seluruh unit pendidikan",
          icon: "fas fa-sitemap",
          rationale: "Sistem yang terintegrasi di semua unit memastikan standar yang sama dan memudahkan koordinasi antar unit dalam proses pembelajaran."
        },
        {
          title: "Implementasi RPP Digital Penuh",
          category: "Program Pendidikan",
          description: "Penerapan pembelajaran digital di seluruh kelas dan mata pelajaran",
          icon: "fas fa-globe",
          rationale: "Implementasi penuh menandai transformasi digital yang sesungguhnya. Semua pembelajaran harus menggunakan RPP digital untuk konsistensi dan efektivitas."
        }
      ]
    },
    {
      month: "Mei 2026",
      monthNumber: "05",
      icon: "fas fa-play",
      color: "from-emerald-500 to-green-600",
      bgColor: "bg-emerald-50",
      borderColor: "border-emerald-500",
      activities: [
        {
          title: "Simulasi Penuh 1 Minggu",
          category: "Program Utama",
          description: "Uji coba sistem digital secara menyeluruh selama satu pekan",
          icon: "fas fa-calendar-week",
          rationale: "Simulasi penuh memberikan gambaran nyata tentang kesiapan sistem dalam kondisi operasional normal. Satu minggu cukup untuk mengidentifikasi masalah yang mungkin muncul."
        },
        {
          title: "Simulasi Penilaian Digital Terpadu",
          category: "Program Pendidikan",
          description: "Uji coba penilaian akademik, karakter, dan ALICI secara terintegrasi",
          icon: "fas fa-puzzle-piece",
          rationale: "Penilaian terpadu mencerminkan filosofi pendidikan holistik pesantren. Simulasi memastikan semua aspek perkembangan santri dapat dinilai secara digital."
        },
        {
          title: "Finalisasi Konten Semester Ganjil 2026/2027",
          category: "Program Utama",
          description: "Penyelesaian materi pembelajaran untuk tahun ajaran baru",
          icon: "fas fa-check-double",
          rationale: "Konten yang siap sebelum tahun ajaran dimulai memastikan pembelajaran dapat berjalan lancar tanpa hambatan teknis atau materi."
        }
      ]
    },
    {
      month: "Juni 2026",
      monthNumber: "06",
      icon: "fas fa-shield-alt",
      color: "from-cyan-500 to-blue-600",
      bgColor: "bg-cyan-50",
      borderColor: "border-cyan-500",
      activities: [
        {
          title: "Refreshment Training Guru & Pengasuh",
          category: "Program Utama",
          description: "Pelatihan penyegaran dan penguatan kemampuan digital",
          icon: "fas fa-sync-alt",
          rationale: "Teknologi terus berkembang dan kemampuan perlu di-refresh. Training ini memastikan guru dan pengasuh tetap update dengan fitur-fitur terbaru sistem."
        },
        {
          title: "Audit Keamanan Data",
          category: "Program Utama",
          description: "Pemeriksaan menyeluruh terhadap keamanan sistem dan data",
          icon: "fas fa-lock",
          rationale: "Data santri adalah amanah yang harus dijaga. Audit keamanan memastikan tidak ada celah yang dapat dieksploitasi dan data terlindungi dengan baik."
        },
        {
          title: "Review Mutu Hasil Belajar Digital",
          category: "Program Pendidikan",
          description: "Analisis hasil pembelajaran berbasis dashboard dan data digital",
          icon: "fas fa-chart-pie",
          rationale: "Data digital memungkinkan analisis yang lebih mendalam tentang pola belajar santri. Review ini membantu optimalisasi strategi pembelajaran."
        }
      ]
    },
    {
      month: "Juli 2026",
      monthNumber: "07",
      icon: "fas fa-flag-checkered",
      color: "from-red-500 to-pink-600",
      bgColor: "bg-red-50",
      borderColor: "border-red-500",
      activities: [
        {
          title: "Finalisasi SOP & Panduan",
          category: "Program Utama",
          description: "Penyelesaian dokumen operasional dan panduan penggunaan",
          icon: "fas fa-book",
          rationale: "SOP yang final dan komprehensif memastikan semua pengguna memiliki panduan yang jelas. Ini penting untuk sustainability program jangka panjang."
        },
        {
          title: "Launching Sistem Digital WIIBS 2026/2027",
          category: "Program Utama",
          description: "Peluncuran resmi sistem digitalisasi untuk tahun ajaran baru",
          icon: "fas fa-rocket",
          rationale: "Launching resmi menandai pencapaian milestone besar dan memberikan momentum positif untuk implementasi penuh sistem digital di tahun ajaran baru."
        },
        {
          title: "Penetapan SOP RPP & Penilaian Digital",
          category: "Program Pendidikan",
          description: "Formalisasi prosedur pembelajaran dan penilaian digital",
          icon: "fas fa-stamp",
          rationale: "Penetapan resmi SOP memberikan kepastian hukum dan operasional. Semua stakeholder memiliki acuan yang jelas untuk implementasi sistem."
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Timeline Roadmap Digitalisasi
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Perjalanan transformasi digital Al Wafi dari September 2025 hingga Juli 2026
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-blue-500 via-purple-500 via-green-500 via-orange-500 to-red-500 rounded-full hidden md:block"></div>

          {/* Timeline Items */}
          <div className="space-y-12">
            {roadmapData.map((monthData, index) => (
              <div key={index} className={`flex items-start ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} flex-col`}>
                {/* Timeline Marker */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-6 h-6 bg-white border-4 border-blue-500 rounded-full shadow-lg z-10 hidden md:block"></div>

                {/* Content */}
                <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:pr-8' : 'md:pl-8'}`}>
                  <div className={`${monthData.bgColor} border-l-4 ${monthData.borderColor} rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer`}
                       onClick={() => setSelectedMonth(selectedMonth === index ? null : index)}>
                    
                    {/* Month Header */}
                    <div className="p-6 border-b border-gray-200">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          <div className={`w-12 h-12 bg-gradient-to-r ${monthData.color} rounded-full flex items-center justify-center`}>
                            <i className={`${monthData.icon} text-white text-lg`}></i>
                          </div>
                          <div>
                            <h2 className="text-2xl font-bold text-gray-800">{monthData.month}</h2>
                            <p className="text-gray-600">{monthData.activities.length} Aktivitas Utama</p>
                          </div>
                        </div>
                        <i className={`fas ${selectedMonth === index ? 'fa-chevron-up' : 'fa-chevron-down'} text-gray-400`}></i>
                      </div>
                    </div>

                    {/* Activities Preview */}
                    <div className="p-6">
                      <div className="grid grid-cols-1 gap-3">
                        {monthData.activities.slice(0, selectedMonth === index ? monthData.activities.length : 2).map((activity, actIndex) => (
                          <div key={actIndex} className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:border-gray-200 transition-all duration-200">
                            <div className="flex items-start space-x-3">
                              <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                                <i className={`${activity.icon} text-gray-600 text-sm`}></i>
                              </div>
                              <div className="flex-1">
                                <h3 className="font-semibold text-gray-800 mb-1">{activity.title}</h3>
                                <p className="text-sm text-blue-600 mb-2">{activity.category}</p>
                                <p className="text-sm text-gray-600 mb-3">{activity.description}</p>
                                
                                {selectedMonth === index && (
                                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mt-3">
                                    <div className="flex items-start space-x-2">
                                      <i className="fas fa-lightbulb text-yellow-500 text-sm mt-0.5"></i>
                                      <div>
                                        <h4 className="font-medium text-yellow-800 mb-1">Mengapa Penting?</h4>
                                        <p className="text-sm text-yellow-700">{activity.rationale}</p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                        
                        {selectedMonth !== index && monthData.activities.length > 2 && (
                          <div className="text-center py-2">
                            <span className="text-sm text-gray-500">
                              +{monthData.activities.length - 2} aktivitas lainnya
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Progress Indicator */}
                    <div className="px-6 pb-6">
                      <div className="flex items-center justify-between text-sm text-gray-500 mb-2">
                        <span>Progress Timeline</span>
                        <span>{Math.round(((index + 1) / roadmapData.length) * 100)}%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className={`bg-gradient-to-r ${monthData.color} h-2 rounded-full transition-all duration-500`}
                          style={{width: `${((index + 1) / roadmapData.length) * 100}%`}}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Summary */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-4">Ringkasan Program</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">11</div>
                <div className="text-blue-100">Bulan Implementasi</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">{roadmapData.reduce((total, month) => total + month.activities.length, 0)}</div>
                <div className="text-blue-100">Total Aktivitas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">5</div>
                <div className="text-blue-100">Program Utama</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">100%</div>
                <div className="text-blue-100">Digital Integration</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
